<template>
    <el-drawer v-model="param.topview" title="商品置顶修改" size="22%" :before-close="closeTop">
        <el-form inline="true">
            <el-form-item class="top20">
                <label class="TTL-form-label">首页置顶截至时间</label>
                <wctime :option="{placeholder:'请选择时间',format:'YYYY-MM-DD HH:mm',ischange:true,type:'datetime',clearable:true}" 
                    :value="param.idx_top_expire" 
                    @finish="(val) => {
                        param.idx_top_expire = val.value;
                    }"
                />
            </el-form-item>
            <el-form-item class="top10">
                <label class="TTL-form-label">列表页置顶截至时间</label>
                <wctime :option="{placeholder:'请选择时间',format:'YYYY-MM-DD HH:mm',ischange:true,type:'datetime',clearable:true}" 
                    :value="param.list_top_expire" 
                    @finish="(val) => {
                        param.list_top_expire = val.value;
                    }"
                />
            </el-form-item>
            <el-form-item class="top20">
                <wcbutton :option="{title:'提交'}" @finish="(val)=> {editGoodsTop()}" />
            </el-form-item>
        </el-form>
    </el-drawer>
</template>

<script>
import INTERFACE_MODEL_GOODS from '@/Interface/Es/Goods/Goods';
export default {
    components:{},
    props:['view','goodsid','idxtop','listtop'],
    data() {
        return {
            param: {
                topview:false,
                id:'',
                idx_top_expire:'',
                list_top_expire:''
            },
        }
    },

    mounted() {
        
    },

    watch: {
        view(val) {
            if(val) {
                this.param.topview = val;
                this.param.id = this.goodsid;
                this.param.idx_top_expire = this.idxtop;
                this.param.list_top_expire = this.listtop;
            }
        }
    },


    methods: {

        //关闭窗口
        closeTop() {
            this.param.topview=false;
            this.$emit('finish');
        },

        /** 手动修改置顶时间 **/
        editGoodsTop() {
            INTERFACE_MODEL_GOODS.EDIT_GOODS_TOP(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.closeTop();
            });
        },

    },
}
</script>
<style scoped>

</style>